export default "__VITE_ASSET__CAILchi1__"